import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import footerScripts from './FooterScripts';
import useCommonScripts from './CommonScripts';
import ScrollTop from './ScrollTop';

const FooterTwo = () => {
  const { t } = useTranslation();
  
  const getArray = (key) => {
    const value = t(key, { returnObjects: true });
    return Array.isArray(value) ? value : [];
  };

  const services = getArray('FooterTwo.form.services');
  const itSolutionItems = getArray('FooterTwo.itSolution.items');
  const quickLinkItems = getArray('FooterTwo.quickLinks.items');

  useEffect(() => {
    footerScripts();
  }, []);

  useCommonScripts();

  return (
    <>
      <footer
        className="footer-wrapper footer-layout2 space-top"
        data-bg-src="assets/img/shape/footer-bg-shape2-1.png"
      >
        <div className="footer-shape1 jump">
          <img src="assets/img/shape/footer-bg-shape2-2.png" alt="img" />
        </div>
        <div className="footer-shape2 jump-reverse">
          <img src="assets/img/shape/footer-bg-shape2-3.png" alt="img" />
        </div>
        <div className="container">
          <div className="footer-top" data-cue="slideInUp">
            <div className="" id="contact-sec">
              <div className="container">
                <div className="row gy-40 gx-60 justify-content-center align-items-center">
                  <div className="col-lg-6">
                    <div className="title-area">
                      <span className="sub-title style2" data-cue="slideInUp">
                        {t('FooterTwo.contact.subTitle')}
                      </span>
                      <h2 className="sec-title" data-cue="slideInUp">
                        {t('FooterTwo.contact.title')}
                      </h2>
                      <p className="sec-text" data-cue="slideInUp">
                        {t('FooterTwo.contact.description')}
                      </p>
                    </div>
                    <div className="contact-feature-wrap">
                      <div className="contact-feature-wrap-details">
                        <div className="contact-feature style2" data-cue="slideInLeft">
                          <div className="box-icon">
                            <i className="far fa-envelope" />
                          </div>
                          <div className="media-body">
                            <h4 className="box-title">{t('FooterTwo.contact.email_title')}</h4>
                            <p className="box-text">
                              <a href="mailto:Enfo@secur.com">Enfo@secur.com,</a>
                              <a href="mailto:Enfo@secur2.com">Enfo@secur2.com</a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="contact-form2" data-cue="slideInUp">
                      <form
                        action="mail.php"
                        method="POST"
                        className="input-label ajax-contact"
                      >
                        <div className="row">
                          <div className="form-group col-sm-6">
                            <input
                              type="text"
                              className="form-control style2"
                              placeholder={t('FooterTwo.form.name')}
                              name="name"
                              id="name"
                              required=""
                            />
                            <i className="far fa-user text-theme" />
                          </div>
                          <div className="form-group col-sm-6">
                            <input
                              type="email"
                              className="form-control style2"
                              placeholder={t('FooterTwo.form.email')}
                              name="email"
                              id="email"
                              required=""
                            />
                            <i className="far fa-envelope text-theme" />
                          </div>
                          <div className="form-group col-sm-6">
                            <input
                              type="number"
                              className="form-control style2"
                              placeholder={t('FooterTwo.form.number')}
                              name="number"
                              id="number"
                              required=""
                            />
                            <i className="far fa-phone text-theme" />
                          </div>
                          <div className="form-group col-sm-6">
                            <select
                              name="subject"
                              id="subject"
                              className="form-select style2"
                            >
                              <option value="" disabled="" defaultValue hidden="">
                                {t('FooterTwo.form.service')}
                              </option>
                              {services.map((item, i) => (
                                <option key={i} value={item}>
                                  {item}
                                </option>
                              ))}
                            </select>
                            <i className="far fa-angle-down text-theme" />
                          </div>
                          <div className="form-group col-12">
                            <textarea
                              name="message"
                              id="message"
                              cols={30}
                              placeholder={t('FooterTwo.form.message')}
                              rows={3}
                              className="form-control style2"
                              required=""
                              defaultValue={""}
                            />
                          </div>
                          <div className="form-btn col-12 mt-10">
                            <button className="ot-btn w-100">
                              {t('FooterTwo.form.submit')}{" "}
                              <i className="far fa-long-arrow-right ms-2" />
                            </button>
                          </div>
                        </div>
                        <p className="form-messages mb-0 mt-3" />
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="widget-area">
            <div className="row justify-content-between">
              <div className="col-md-6 col-xl-auto" data-cue="slideInUp">
                <div className="widget footer-widget">
                  <div className="ot-widget-about">
                    <div className="about-logo">
                      <Link to="/">
                        <img src="assets/img/logo.svg" alt="Secur" />
                      </Link>
                    </div>
                    <p className="about-text">
                      {t('FooterTwo.about.text')}
                    </p>
                    <div className="ot-social">
                      <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-facebook-f" />
                      </a>
                      <a href="https://www.twitter.com/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-twitter" />
                      </a>
                      <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-linkedin-in" />
                      </a>
                      <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-youtube" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-auto" data-cue="slideInUp">
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">{t('FooterTwo.itSolution.title')}</h3>
                  <div className="menu-all-pages-container">
                    <ul className="menu">
                      {itSolutionItems.map((item, i) => (
                        <li key={i}>
                          <Link to="/service">{item}</Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-auto" data-cue="slideInUp">
                <div className="widget widget_nav_menu footer-widget">
                  <h3 className="widget_title">{t('FooterTwo.quickLinks.title')}</h3>
                  <div className="menu-all-pages-container">
                    <ul className="menu">
                        {quickLinkItems.map((item, i) => (
                            <li key={i}>
                                <Link to={item.url}>{item.label}</Link>
                            </li>
                        ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xl-auto" data-cue="slideInUp">
                <div className="widget footer-widget">
                  <h3 className="widget_title">{t('FooterTwo.contactInfo.title')}</h3>
                  <div className="ot-widget-contact">
                    <div className="info-box">
                      <div className="box-icon">
                        <i className="far fa-map-marker-alt" />
                      </div>
                      <div className="media-body">
                        <h3 className="box-title">{t('FooterTwo.contactInfo.locationTitle')}</h3>
                        <p className="box-text">
                          {t('FooterTwo.contactInfo.location')}
                        </p>
                      </div>
                    </div>
                    <div className="info-box">
                      <div className="box-icon">
                        <i className="far fa-phone" />
                      </div>
                      <div className="media-body">
                        <h3 className="box-title">{t('FooterTwo.contactInfo.phoneTitle')}</h3>
                        <a className="box-link" href="tel:16555778749">
                          +165-5577-8749,
                        </a>
                        <a className="box-link" href="tel:16535647488">
                          +165-3564-7488
                        </a>
                      </div>
                    </div>
                    <div className="info-box">
                      <div className="box-icon">
                        <i className="far fa-clock" />
                      </div>
                      <div className="media-body">
                        <h3 className="box-title">{t('FooterTwo.contactInfo.openingTitle')}</h3>
                        <p className="box-text">{t('FooterTwo.contactInfo.opening')}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="copyright-wrap">
          <div className="container text-center">
            <div className="row gy-3 justify-content-between align-items-center">
              <div className="col-md-auto" data-cue="slideInLeft">
                <p className="copyright-text">
                  <i className="fal fa-copyright" /> {t('FooterTwo.copyright.text')}
                </p>
              </div>
              <div className="col-md-auto">
                <div className="footer-links" data-cue="slideInRight">
                  <ul>
                    <li>
                      <Link to="/about">{t('FooterTwo.copyright.terms')}</Link>
                    </li>
                    <li>
                      <Link to="/about">{t('FooterTwo.copyright.privacy')}</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <ScrollTop />
    </>
  );
};

export default FooterTwo;